// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination, Autoplay, EffectFade, Controller } from 'swiper/core';

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Controller]);

const Swipers = {}

Swipers.pageBannerContent = new SwiperCore('.page-banner__slider-content', {
	slidesPerView: 1,
	allowTouchMove: false,
	autoHeight: true,
	loop: true,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	speed: 500,
	controller: {
		control: Swipers.pageBanner
	},
	
});

Swipers.pageBanner = new SwiperCore('.page-banner__slider', {
	slidesPerView: 1,
	loop: true,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	speed: 500,
	controller: {
		control: Swipers.pageBannerContent
	},
	pagination: {
		el: '.page-banner__slider-pagination',
		type: 'bullets',
		clickable: true
	},
});

let articleTileSlider = $('.article-tile-slider')[0];

Swipers.tileSwiper = new SwiperCore(articleTileSlider, {
	loop: false,
	slidesPerView: 1,
	spaceBetween: 40,
	freeMode: false,
	breakpoints: {
		1024: {
			slidesPerView: 3
		},
		768: {
			slidesPerView: 2
		},
		640: {
			slidesPerView: 1
		}
	},
	speed: 400,
	pagination: {
		el: '.article-tile-slider .tile-slider__pagination',
		type: 'bullets',
		clickable: true
	},
	navigation: {
		nextEl: '.section--slider-articles .tile-slider__nav-item--next',
		prevEl: '.section--slider-articles .tile-slider__nav-item--prev',
	},
});

if ($(window).width() > 767) {

	let i;
	for (i = 1; i < 11; i++) {

		let sPVDesktop = 3;
		let swEl = $('.tile-slider--' + i);
		let swElDataSmall = $(swEl).data('small');
		sPVDesktop = (swElDataSmall == true) ? 4 : 3;

		Swipers.tileSwiper = new SwiperCore('.tile-slider--' + i, {
			loop: false,
			slidesPerView: 1,
			spaceBetween: 16,
			freeMode: false,
			breakpoints: {
				1024: {
					slidesPerView: 3,
					spaceBetween: 40
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 40
				},
				640: {
					slidesPerView: 1,
					spaceBetween: 16
				}
			},
			speed: 400,
			pagination: {
				el: '.tile-slider__pagination',
				type: 'bullets',
				clickable: true
			},
			navigation: {
				nextEl: '.tile-slider__nav-item--next--' + i,
				prevEl: '.tile-slider__nav-item--prev--' + i,
			},
		});


		Swipers.tileSwiper = new SwiperCore('.content-slider--' + i, {
			loop: false,
			slidesPerView: 1,
			freeMode: false,
			speed: 600,
			pagination: {
				el: '.content-slider__pagination',
				type: 'bullets',
				clickable: true
			},
			navigation: {
				nextEl: '.content-slider__nav-item--next--' + i,
				prevEl: '.content-slider__nav-item--prev--' + i,
			},
		});
	}
}

